// utils/dateFormatters.ts
export const formatDateOnly = (date?: string) =>
  date ? new Date(date).toLocaleDateString() : '—';

export const formatDateTime = (datetime?: string) =>
  datetime ? new Date(datetime).toLocaleString() : '—';


// utils/dateFormatters.ts
export const formatFriendlyDateTime = (dateStr?: string | Date): string => {
  if (!dateStr) return '';
  const date = typeof dateStr === 'string' ? new Date(dateStr) : dateStr;
  return date.toLocaleString('es-SV', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};


// utils/dateFormatters.ts

export const getTodayDateString = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0'); // meses van de 0 a 11
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`; // formato yyyy-MM-dd
};
